import { type FC } from 'react';

import { useCardOfferDataContext } from '@/microfrontends/listing/shared/context/selectors/cardData';

import { CardPriceBlock } from './CardPriceBlock';

export const CardPriceBlockContainer: FC = () => {
  const {
    terms: { vat, price },
  } = useCardOfferDataContext();

  return <CardPriceBlock priceTitle={price} vatTitle={vat} />;
};
